export interface RouteLink {
  label: string
  to: string
}

export const routeLinks: RouteLink[] = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Executive Profile', to: '/executive-profile' },
  { label: 'Experience', to: '/experience' },
  { label: 'Skills', to: '/skills' },
  { label: 'Education', to: '/education' },
  { label: 'Advisory', to: '/advisory' },
  { label: 'Books & Media', to: '/books-and-media' },
  { label: 'Honors', to: '/honors' },
  { label: 'Contact', to: '/contact' },
]
